import axios from "axios";
import env from "../config";
// import { setNotification, useNotifcation } from 'context/notification'
import { ReqMethods, ResponseStatus } from "../enums";
// import { useAuth, useLogout } from './auth'

const BASE_URL = `${env.API_URL}`;

function useServiceHandler() {
  // const [, dispatch] = useNotifcation()
  // const Logout = useLogout()

  return (fn) =>
    async (
      method,
      path,
      { query, payload, token, apiKey, toaster, message, error } = {}
    ) => {
      try {
        const res = await fn(method, path, { query, payload, token, apiKey });
        // console.log("API - RESPONSE", res, toaster, message, error);
        // toaster &&
        //   setNotification(dispatch, {
        //     open: true,
        //     message: message || res.data.message,
        //     severity: 'success',
        //     title: 'Success',
        //   })

        return { response: res.data };
      } catch (err) {
        // console.log("API- ERROR", err.response?.data || err);

        // expire error : jwt expired
        if (
          err.response &&
          err.response.status === ResponseStatus.UNAUTHORIZED
        ) {
          // setNotification(dispatch, {
          //   open: true,
          //   message: error || 'session expired',
          //   title: 'Error',
          //   severity: 'error',
          // })
          // setTimeout(Logout, 4000)
          return { error: err.response?.data || err };
        }

        const customError = err.response?.data?.error
          ? `${err.response?.data?.message} \n${err.response?.data?.error}`
          : err.response?.data?.message;

        // toaster &&
        //   setNotification(dispatch, {
        //     open: true,
        //     message: error || customError || err.message,
        //     severity: 'error',
        //     title: 'Error',
        //   })
        return { error: err.response ? err.response.data : err };
      }
    };
}

function useCallService() {
  // const authToken = useAuth()
  const serviceHandler = useServiceHandler();

  const CallService = (
    method,
    path,
    { query, payload, token = true, apiKey = null }
  ) => {
    const pathname = query ? `${path}?${query}` : path;
    const config = {};

    // if (token) config.headers = { 'x-auth-token': `Bearer ${authToken || token}` }
    // if (apiKey) config.headers = { apiKey }

    const details = {};

    if (payload) details.payload = payload;
    details.config = config;

    return axios[method](pathname, ...Object.values(details));
  };

  return serviceHandler(CallService);
}

function useAppServices() {
  const { GET, POST, PUT, DELETE } = ReqMethods;
  const CallService = useCallService();

  /**
    Option for service is the object that could has the following properties
    query, payload, token, apiKey
  */

  const APIs = {
    auth: {
      integrate_app: (options) =>
        CallService(POST, `${BASE_URL}/auth/integrate_app`, options),
      login: (options) => CallService(POST, `${BASE_URL}/auth/login`, options),
      superadmin_login: (options) =>
        CallService(POST, `${BASE_URL}/auth/superadmin_login`, options),
    },
    webhook: {
      qr_code: (options) =>
        CallService(GET, `${BASE_URL}/webhook/qr_code`, options),
      bulkmessage: (options) =>
        CallService(POST, `${BASE_URL}/webhook/bulkmessage`, options),
    },
    apps: {
      get: (options) => CallService(GET, `${BASE_URL}/apps`, options),
      create: (options) => CallService(POST, `${BASE_URL}/apps`, options),
      filter: (options) => CallService(GET, `${BASE_URL}/apps/filter`, options),
      update: (options) => CallService(PUT, `${BASE_URL}/apps`, options),
      delete: (options) => CallService(DELETE, `${BASE_URL}/apps`, options),
    },
    support: {
      get_tickets: (options) =>
        CallService(GET, `${BASE_URL}/support/get_tickets`, options),
      get_tickets_with_messages: (options) =>
        CallService(
          GET,
          `${BASE_URL}/support/get_tickets_with_messages`,
          options
        ),
      create_ticket: (options) =>
        CallService(POST, `${BASE_URL}/support/create_ticket`, options),
    },
    provider_requests: {
      get: (options) =>
        CallService(GET, `${BASE_URL}/provider_requests`, options),
      create: (options) =>
        CallService(POST, `${BASE_URL}/provider_requests`, options),
      filter: (options) =>
        CallService(GET, `${BASE_URL}/provider_requests/filter`, options),
      update: (options) =>
        CallService(PUT, `${BASE_URL}/provider_requests`, options),
      delete: (options) =>
        CallService(DELETE, `${BASE_URL}/provider_requests`, options),
    },
    user: {
      get: (options) => CallService(GET, `${BASE_URL}/user`, options),
      filter: (options) => CallService(GET, `${BASE_URL}/user/filter`, options),
      GetTeam: (options) => CallService(GET, `${BASE_URL}/user/teams`, options),
      assignSim: (options) =>
        CallService(PUT, `${BASE_URL}/user/assignSim`, options),
    },
    agency: {
      get: (options) => CallService(GET, `${BASE_URL}/agency`, options),
      filter: (options) =>
        CallService(GET, `${BASE_URL}/agency/filter`, options),
      update: (options) => CallService(PUT, `${BASE_URL}/agency`, options),
      getProducts: (options) =>
        CallService(PUT, `${BASE_URL}/agency/getproducts`, options),
    },
    ghlapis: {
      getcontacts: (options) =>
        CallService(GET, `${BASE_URL}/ghlapis/getcontacts`, options),
      make_wallet_charge: (options) =>
        CallService(POST, `${BASE_URL}/ghlapis/make_wallet_charge`, options),
    },
    utils: {
      upload_image: (options) =>
        CallService(POST, `${BASE_URL}/utils/upload/image`, options),
    },
    services: {
      ghl: {
        call_service: (options) =>
          CallService(POST, `${BASE_URL}/hooks/ghl/`, options),
      },
    },
  };

  return APIs;
}
const useUploadImage = () => {
  const AppService = useAppServices();
  return ({ toaster, file, desiredPath }) => {
    const form = new FormData();
    form.append("image", file, file.name);
    return AppService.utils.upload_image({
      toaster,
      payload: form,
      query: `desiredPath=${desiredPath}`,
    });
  };
};
export { useAppServices, useCallService, useUploadImage };
